import { Modal, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { AuthenticatedDownloadLink } from "../../../../../components/document/AuthenticatedDownloadLink";

export default function ExportDialog({ show, onHide, options = [] }) {
  const anyZip =
    Array.isArray(options) &&
    options.some((opt) =>
      String(opt?.filename || opt?.url || "")
        .toLowerCase()
        .endsWith(".zip")
    );

  const resolveMeta = (opt) => {
    const name = opt?.filename || opt?.url || "";
    const lower = String(name).toLowerCase();

    const isXlsx = lower.endsWith(".xlsx");
    const isPdf = lower.endsWith(".pdf");
    const isZip = lower.endsWith(".zip");

    if (isZip) {
      const inner = (opt?.zipInnerType || "").toLowerCase();
      if (inner === "xlsx") {
        return {
          type: "zip-xlsx",
          variant: opt.variant ?? "success",
          iconClass: "fa-regular fa-file-excel",
          labelId: "indicator.exportar.excels",
          formatId: "indicator.exportar.excel.format",
          formatDefault: "",
        };
      }
      if (inner === "pdf") {
        return {
          type: "zip-pdf",
          variant: opt.variant ?? "danger",
          iconClass: "fa-regular fa-file-pdf",
          labelId: "indicator.exportar.pdfs",
          formatId: "indicator.exportar.pdf.format",
          formatDefault: "",
        };
      }
    }

    if (isXlsx) {
      return {
        type: "xlsx",
        variant: opt.variant ?? "success",
        iconClass: "fa-regular fa-file-excel",
        labelId: "indicator.exportar.excel",
        labelDefault: "indicator.exportar.excel",
        formatId: "indicator.exportar.excel.format",
      };
    }
    if (isPdf) {
      return {
        type: "pdf",
        variant: opt.variant ?? "danger",
        iconClass: "fa-regular fa-file-pdf",
        labelId: "indicator.exportar.pdf",
        labelDefault: "indicator.exportar.pdf",
        formatId: "indicator.exportar.pdf.format",
      };
    }
  };

  const renderOption = (opt) => {
    const meta = resolveMeta(opt);
    const hasCustomLabel =
      typeof opt.label === "string" && opt.label.length > 0;
    const hasCustomSubtitle =
      typeof opt.subtitle === "string" && opt.subtitle.length > 0;

    const LabelNode = hasCustomLabel ? (
      opt.label
    ) : (
      <FormattedMessage id={meta.labelId} defaultMessage={meta.labelDefault} />
    );

    const SubtitleNode = hasCustomSubtitle ? (
      opt.subtitle
    ) : (
      <FormattedMessage
        id={meta.formatId}
        defaultMessage={meta.formatDefault}
      />
    );

    const button = (
      <Button
        variant={meta.variant}
        className="w-100 text-start d-flex align-items-center justify-content-between"
        aria-label={`Download ${
          hasCustomLabel ? opt.label : meta.labelDefault
        }`}
        onClick={
          opt.onClick
            ? () => {
                opt.onClick();
              }
            : undefined
        }
        as={opt.onClick ? "button" : "span"}
      >
        <span className="d-flex align-items-center gap-2">
          <i className={meta.iconClass} aria-hidden="true" />
          <span className="fw-semibold">{LabelNode}</span>
        </span>
        <small className="text-white-50">{SubtitleNode}</small>
      </Button>
    );

    if (typeof opt.onClick === "function") {
      return (
        <div key={`${opt.filename || opt.url || meta.type}-action`}>
          {button}
        </div>
      );
    }

    return (
      <AuthenticatedDownloadLink
        key={`${opt.filename || opt.url || meta.type}-dl`}
        url={opt.url}
        filename={opt.filename}
        onClick={onHide}
      >
        {button}
      </AuthenticatedDownloadLink>
    );
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        aria-labelledby="export-dialog-title"
        dialogClassName="export-dialog-wider"
      >
        <Modal.Header closeButton>
          <Modal.Title id="export-dialog-title">
            <FormattedMessage
              id="indicator.exportar.opcoes"
              defaultMessage="Opções de Exportação"
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!options || options.length === 0 ? (
            <div className="text-muted">
              <FormattedMessage
                id="indicator.exportar.sem.opcoes"
                defaultMessage="Sem opções de exportação disponíveis."
              />
            </div>
          ) : (
            <>
              <p className="mb-3">
                {anyZip ? (
                  <FormattedMessage id="indicator.exportar.escolhaFormato.zip" />
                ) : (
                  <FormattedMessage id="indicator.exportar.escolhaFormato" />
                )}
              </p>
              <div className="d-flex flex-column gap-2">
                {options.map(renderOption)}
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer className="justify-content-between">
          <Button variant="outline-primary" onClick={onHide}>
            <FormattedMessage id="all.close" defaultMessage="Fechar" />
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .modal-dialog.export-dialog-wider { --bs-modal-width: 420px; }
      `}</style>
    </>
  );
}